module.exports = __webpack_public_path__ + "static/media/gif.759348c7.png";